import { createResource } from 'react-resource-router';
export { getTeams } from '../endpoints';

export const getTeamsResource = createResource({
	type: 'getTeamsResource',
	getKey: () => 'overview',
	getData: async () => {
		throw new Error(
			'getData of getTeamsResource is not implemented in platform package, you should do it in your product',
		);
	},
	isBrowserOnly: true,
});
